import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "RSVP" */ './lazyIndex'),
    {
        name: 'RSVP',
    }
);

export const lazyTryPrefetchMeetingMessage: LazyAction<
    typeof lazyIndex.tryPrefetchMeetingMessage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.tryPrefetchMeetingMessage);

export const lazyRemoveMeetingMessagesFromStore: LazyAction<
    typeof lazyIndex.removeMeetingMessagesFromStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeMeetingMessagesFromStore);
